@if (['text', 'email', 'tel'].includes(type)) {
  @if (label) {
    <label [class.font-bold]="boldLabel">{{ label }}</label>
  }
  <input
    [type]="type"
    [attr.inputmode]="inputMode || null"
    [attr.pattern]="digitsOnly ? '[0-9]*' : null"
    [placeholder]="placeholder ? placeholder : ''"
    [value]="value ? value : ''"
    (input)="digitsOnly ? onChangeTextValue($event) : null"
    (keyup)="onChangeTextValue($event)"
    (keyup.enter)="unfocus($event.target)"
    autofocus
  />
}
@if (type === 'radio') {
  <label
    [for]="id ?? label"
    class="-mx-3 flex cursor-pointer flex-col rounded-lg border p-3 transition-colors hover:border-neutral-300 hover:bg-neutral-100"
    [class.border-neutral-300]="active"
    [class.bg-neutral-100]="active"
    [class.border-transparent]="!active"
  >
    <div class="flex items-center">
      <input
        [id]="id ?? label"
        [type]="type"
        [checked]="active"
        (change)="onChangeValueRadio(value)"
        class="form-radio h-5 w-5 border text-primary-600"
      />
      @if (label) {
        <span
          class="ml-3"
          [class.font-bold]="boldLabel"
          >{{ label }}</span
        >
      }
    </div>
    <ng-content></ng-content>
  </label>
}
@if (type === 'checkbox') {
  <input
    [id]="id ?? label"
    [type]="type"
    [checked]="value"
    (change)="onChangeValueCheckbox($event)"
    class="form-checkbox m-3 h-6 w-6 border text-primary-600"
  />
  @if (label) {
    <label
      class="ml-2"
      [class.font-bold]="boldLabel"
      [for]="id ?? label"
      >{{ label }}</label
    >
  }
}
